export { default } from './head.js'



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash-es/first.js
// module id = 3493
// module chunks = 0